import { Injectable } from '@angular/core';
import { PortalData, Pub_files, PublicationsDataList, PublicationsSearchCriteria } from '../_models/publications';
import { Observable } from 'rxjs';
import { HttpClient, HttpEvent, HttpHeaders } from '@angular/common/http';
import { AppConstants } from 'src/shared/AppConstants';
import { DeviceDetectorService, DeviceInfo } from 'ngx-device-detector';
import { AuthenticationService } from './authentication.service';
import { DomSanitizer, SafeUrl, Title } from '@angular/platform-browser';
import { FileStoreType } from '../_enums/constant-types.enum';
import { PortalProfiles, SearchComponents } from '../_models/portals';
import { UtilityService } from './utility.service';

@Injectable({
  providedIn: 'root'
})
export class PublicationsService {
  deviceInfo: DeviceInfo;
  httpOptions = { headers: new HttpHeaders({ 'content-type': 'application/json', 'Accept': 'application/json' }) };

  constructor(private http: HttpClient,private utilityService: UtilityService) {

  }

  getPublicationsData(Criteria: PublicationsSearchCriteria): Observable<PortalData> {
    Criteria.Environment_Id = AppConstants.EnvironmentId;
    let profileinfo = this.utilityService.getSelectedProfile();
    if (profileinfo.PK_ENV_PROFILE_ID) {
      Criteria.Profile_Id = profileinfo.PK_ENV_PROFILE_ID;
    }
    return this.http.post<PortalData>(AppConstants.PortalApiBaseUrl + '/api/Publications/GetPortalsPublicationsData', Criteria);
  }
  
  ViewURL(therapeuticId: string, prodId: string, url:string, fileName: string = "",Profile_Id:string=""): Observable<PublicationsSearchCriteria> {
    let profile_id: string = '';
    let profileinfo: PortalProfiles = {};
    profileinfo = this.utilityService.getSelectedProfile();
    if (profileinfo.PK_ENV_PROFILE_ID) {
      profile_id = profileinfo.PK_ENV_PROFILE_ID;
    }
   
    let Criteria={
    Therapeutic_Area_Id: therapeuticId,
    Product_Id : prodId,
    Publication_URL : url,
    fileName:fileName,
    Profile_Id:profile_id,
    Environment_Id:AppConstants.EnvironmentId,
   }
   
    return this.http.post<PublicationsSearchCriteria>(AppConstants.PortalApiBaseUrl + '/api/Publications/GetPublicationsAnalyticsData', Criteria);
  }


  // getPublicationsData(): Observable<Array<PublicationsData>>{   
  //   return this.http.get<Array<PublicationsData>>(AppConstants.PortalApiBaseUrl + '/api/Publications/GetPortalsPublicationsData/' + AppConstants.EnvironmentId);
  // }
}
